<template>
  <div>
    <div class="main">
    <v-carousel v-model="model" :show-arrows="false" :hide-delimiters="true" height="100%" continuous>
      <v-carousel-item>
        <div class="wrapper">
          <div class="feature-overlay fill">
            <div class="radar">
              <p class="circle" style="animation-delay: -3s"></p>
              <p class="circle" style="animation-delay: -1.5s"></p>
              <p class="circle" style="animation-delay: 0s"></p>
              <div class="icon-pin">
                <v-icon size="30" color="#fff">
                  {{icons.mdiMagnify}}
                </v-icon>
              </div>
              <div class="label-find">
                <h2>Finding you a driver...</h2>
              </div>
            </div>
          </div>
        </div>
      </v-carousel-item>
      <v-carousel-item >
      <div class="wrapper">
        <div class="map">
          <track-driver-map :location="location" />
        </div>
        <div class="feature-overlay transparent">
          <div class="radar">
            <p class="circle" style="animation-delay: -4s"></p>
            <p class="circle" style="animation-delay: -2s"></p>
            <p class="circle" style="animation-delay: 0s"></p>

            <div class="label-find">
              <div>{{messageStatus()}}</div>
            </div>
          </div>
          
          <div v-if="deliveryStatus != 5" class="countdown">
            <van-count-down :time="time" @finish="finishCount" @change="change" />
            <div class="timer">Timer</div>
          </div>

          <div v-if="deliveryStatus != 5" class="btn-wrap">
            <button v-if="isContinue && !disabled" @click="addTime" class="search">
              Continue Search
            </button>
            <button @click="cancel" class="cancel">
              Cancel Order
            </button>
          </div>

          <!-- <div class="btn-wrap" v-if="deliveryStatus == 5">
            <button class="search" @click="openCrisp">
              Live Chat with Us
            </button>
          </div> -->
        </div>
      </div>
      </v-carousel-item>
    </v-carousel>

    </div>
  </div>

</template>
<script>
import { mdiMagnify,mdiPin } from '@mdi/js';
import mockDemo from '@/api/mock2';
import trackDriverMap from '@/components/gmap/trackDriverMap.vue';
import { getOrderDriverInfo } from '@/api/api'
import TrackDriverMap from '../../components/gmap/trackDriverMap.vue';
import { getApiFindDriver } from '@/api/api2'

export default{
	name: "TrackDriver",
	components: {
		TrackDriverMap
	},
	props: {
		orderInfo: {
			type: Object,
			default: () => {}
		},
    orderRes: {
      type: Object,
      default: () =>{}
    },
    deliveryStatus: {
      type: Number,
    },
    location: {
      type: Object
    }
	},
	data() {
		return{
      disabled: false,
      addedTime: 0,
      isContinue: false,
			model: 0,
			time: 5 * 60 * 1000,
			icons: {
				mdiMagnify,
				mdiPin
			},
		}
	},
	created() {
		setTimeout(() => {
			this.model=1
		}, 1000);
    this.messageStatus()
    this.countDownFn()

    if(this.$route.hash == '#addtime') {
      this.disabled = true
      this.addedTime = 5 * 60 * 1000
    }
	},
	watch:{
		deliveryStatus: {
			handler(val, oldVal){
        console.log('deliveryStatus...',this.deliveryStatus)
        if(this.deliveryStatus != 0 || this.deliveryStatus != 5 ){
          this.delivering()
        }
		}
	}
  },
	methods: {
    // openCrisp() {
    //   this.$crisp.load('49f6327e-5f6b-4baf-9cf3-ba48e34595c7')
    // },
    addTime() {
      function parseParms(str) {
          var pieces = str.split("&"), data = {}, i, parts;
          // process each query pair
          for (i = 0; i < pieces.length; i++) {
              parts = pieces[i].split("=");
              if (parts.length < 2) {
                  parts.push("");
              }
              data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
          }
          return data;
      }

      if(this.$route.hash != '#addtime'){
        let hashing = '#addtime'
        let queryObjs = location.href.split("?")[1]
        const parseObjs = parseParms(queryObjs)
        const params = new URLSearchParams(parseObjs);
        const query = params.toString();
        const url =location.href.split("?")[0]+`?${query}`+`${hashing}`
        
        this.disabled = true
        this.addedTime = 5 * 60 * 1000
        history.replaceState({},'', url)
      }

      this.countDownFn()
    },  
    change() {
      let scheduleTime = this.orderInfo.schedule_datetime
      let currTime = new Date().getTime() 
      let addedTime = new Date(scheduleTime).getTime() + (5 * 60 * 1000)
      let diffTime = addedTime - currTime
      if(diffTime < 1*60*1000){
        this.isContinue = true
      }
    },
    countDownFn() {
      let scheduleTime = this.orderInfo.schedule_datetime
      let currTime = new Date().getTime() 
      let addedTime = new Date(scheduleTime).getTime() + (5 * 60 * 1000) + this.addedTime
      let diffTime = addedTime - currTime

      this.time = diffTime
    },
    messageStatus(){
      let status = this.deliveryStatus
      if(status == 0){
        return "One moment, we're looking driver for your order."
      }else if(status == 1){
        return "Great. Found a driver for your order."
      }else if(status == 2){
        return "Be calm, Be safety, Be patient. Your rider is heading to your location."
      }else if(status == 3){
        return "Awesome, your order is completed and thanks for ordering with us. Enjoy!"
      }else if(status == 5) {
        return "Something wrong with your order. Please contact our support for further information."
      }
    },
    finishCount(){
      console.log('...finish countdown')
      this.$emit('cancel')
      this.removeFragm()
    },
    cancel(){
      console.log('...cancel order')
      this.$emit('cancel')
      this.removeFragm()
    },
    delivering(){
      console.log('...found driver')
      this.$emit('close-overlay')
      this.removeFragm()
    },
    removeFragm(){
      function parseParms(str) {
          var pieces = str.split("&"), data = {}, i, parts;
          // process each query pair
          for (i = 0; i < pieces.length; i++) {
              parts = pieces[i].split("=");
              if (parts.length < 2) {
                  parts.push("");
              }
              data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
          }
          return data;
      }

      if(location.hash.includes('#addtime')){
        let hashing = '#addtime'
        let url = location.hash.replace(hashing,'')
        history.replaceState({},'', url)
      }
      return
    }
	}
}

</script>
<style scoped lang="less">
@import url('../../assets/css/common.less');
.main{
	height: 100vh;
	width: 100vw !important;
}
.wrapper{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	height: 100%;
	width: 100%;
	overflow: hidden;
}
.feature-overlay{
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column !important;
	align-items: center !important;
}
.fill{
	background: @main;
	height: 100%;
  justify-content: center;
	.label-find{
		background: transparent;
		box-shadow: none;
		color: #fff;
	}
	.radar{
    display : flex;
    justify-content: center;
    align-items: center;
		.circle{
			background:	rgba(231, 231, 231, 0.2);
			box-shadow: 0 0 0 1px white;
		}
	}
}
.transparent{
  height: 100%;
  justify-content: center !important;
	.radar{
		margin: auto;
		transform: translateY(-25px);
	}
}
.radar{
	position: relative;
	height: 320px;
	width: 320px;
	display: flex;
  align-items: center;
  justify-content: center;
	.circle{
		border-radius: 50%;
		position: absolute;
		margin: 0 auto;
		animation: circle-animate 6s infinite cubic-bezier(.36, .11, .89, .32);
		opacity: 0;
		background:	rgba(0, 191, 255, 0.2);
		box-shadow: 0 0 0 1px deepskyblue;
		height:150px;
		width: 150px;
	}
}
.radar p:nth-child(1){
	z-index:3;
	animation-delay: 0s;
}
.radar p:nth-child(2){
	animation-delay: 2s;
	z-index:2;
}
.radar p:nth-child(3){
	animation-delay: 3s;
	z-index: 1;
}

.icon-pin{
	position: absolute;
	z-index: 4;
	height: 60px;
	width: 60px;
	position: absolute; 
	margin: auto;
	border-radius: 50%;
	display: grid;
	place-items: center;
	transition: 0.5s ease-in;
}

.label-find{
	transform: translateY(170px);
	position: absolute;
	z-index: 4;
	background: #fff;
	color: #666;
	padding: .5rem 0;
	box-shadow: 3px 3px 5px 1px rgb(160, 160, 160);
	border-radius: 3px;
	// max-width: 290px;
	width: 100%;
	text-align: center;
	h2{
		font-size: 1.3rem;
		font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
		font-weight: 500;
		padding: 0 2rem ;
	}
	@media only screen and (max-width: 340px) {
    width: 80%;
    font-size: 13px;
		h2{
			font-size: 1rem;
		}
	}
}
.countdown{
	position: absolute;
	top: 10px;
  width: 95%;
	z-index: 2;
	text-align: center;
	background: #fff ;
	padding: .6rem 3rem 0.2rem;
	box-shadow: 3px 3px 5px 1px rgb(160, 160, 160);
	border-radius: 3px;
	.van-count-down{
		color: #666!important;
		font-size: 1.5rem;
	}
	.timer{
		color: darkgray;
	}

	@media only screen and (max-width: 340px) {
		.van-count-down{
			font-size: 1.2rem;
		}
		.timer{
			font-size: 0.8rem;
		}
	}
}
.btn-wrap{
  display: flex;
  flex-direction: column;
	position: absolute;
	width: 95%;
	bottom: 1rem;

  .cancel, .search {
    margin-top: 1rem;
    box-shadow: 3px 3px 5px 3px rgb(160, 160, 160);
    padding: 1rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
  }

  .search{
    background: #fff;
    color: gray;
  }
  .cancel{
    background: @main;
    color: #fff;
  }
	@media only screen and (max-width: 340px) {
    .cancel, .search {
      padding: 0.6rem;
    }
	}
}

@keyframes circle-animate {
	from {
		transform: scale(.5, .5);
		opacity: .9;
	}
	to {
		transform: scale(2, 2);
		opacity: 0;
	}
}
</style>

